import React from 'react';
import { Box } from '@mui/material';

interface PendingRequestsBadgeProps {
  count: number;
  max?: number;
}

const PendingRequestsBadge: React.FC<PendingRequestsBadgeProps> = ({ count, max = 99 }) => {
  if (count <= 0) {
    return null;
  }

  const displayValue = count > max ? `${max}+` : String(count);

  return (
    <Box
      component="span"
      sx={{
        ml: 1,
        minWidth: 18,
        height: 18,
        px: 0.75,
        borderRadius: '999px',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: 'error.main',
        color: 'error.contrastText',
        fontSize: '0.7rem',
        fontWeight: 700,
        lineHeight: 1,
      }}
      aria-label={`${count} pending permission requests`}
      title={`${count} pending permission requests`}
    >
      {displayValue}
    </Box>
  );
};

export default PendingRequestsBadge;
